import type { CPNavigationInput } from '@common/navigation-layer/types/navigation'

const LEGACY_MEMBERS_SEGMENTS = new Set(['member-list', 'members-list'])

/** Legacy API paths like `{groupSlug}/member-list?memberStatus=Requested` → members + hash. */
export function resolveCommunitiesNotificationNavigation(redirectionUrl: string): CPNavigationInput | null {
  const normalized = redirectionUrl.replace(/^\/+/, '')
  const [pathPart, queryPart = ''] = normalized.split('?')
  const [groupSlug, section] = pathPart.split('/').filter(Boolean)

  if (!groupSlug || !section || !LEGACY_MEMBERS_SEGMENTS.has(section)) {
    return null
  }

  const hash = new URLSearchParams(queryPart).get('memberStatus')?.toLowerCase()

  return {
    name: 'communities-groups-members',
    params: { groupSlug },
    ...(hash ? { hash } : {}),
  }
}
